import { render, staticRenderFns } from "./cardDetail.vue?vue&type=template&id=383c37b0&scoped=true"
import script from "./cardDetail.vue?vue&type=script&lang=js"
export * from "./cardDetail.vue?vue&type=script&lang=js"
import style0 from "./cardDetail.vue?vue&type=style&index=0&id=383c37b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "383c37b0",
  null
  
)

export default component.exports